import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LIVESETTINGS,
  LIVESETTINGSALL,
  BRANDALL,
} from "../../services/actions";
import { Box, Grid, Button, Card, TextField, Pagination } from "@mui/material";
import { BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import InfoCard from "../extra/InfoCard";
import camPng from "./camsettings.png";

export default function View() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { brand } = location.state || {};

  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const ref2 = React.useRef();

  const brandallState = useSelector((state) => state?.brandallState);
  const livesettingsallState = useSelector(
    (state) => state?.livesettingsallState
  );
  const livesettingsState = useSelector((state) => state?.livesettingsState);
  const user = useSelector((state) => state?.loginState?.auth);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchCamSettings = (page = 0) => {
    let url =
      page === 0 ? `livesettings/${page}/` : `livesettings/?page=${page}`; // pass page number
    if (brand?.id) {
      url = `livesettings/0/?filter_by={"brand_id":${brand?.id}}`;
    }
    dispatch({ type: `${LIVESETTINGSALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    fetchCamSettings(page);
  }, [page]);

  React.useEffect(() => {
    //dispatch({ type: `${LIVESETTINGSALL}_GET`, payload: 0 });
    fetchCamSettings(0);
    dispatch({ type: `${BRANDALL}_GET`, payload: 0 });
  }, []);

  React.useEffect(() => {
    if (livesettingsState?.success) {
      setOpen(false);
      dispatch({ type: `${LIVESETTINGSALL}_GET`, payload: 0 });
    }

  }, [livesettingsState.data]);

  return (
    <>
      <RDialog
        title="Add Camera Urls"
        open={open}
        handleClose={() => setOpen(false)}
      >
        <Form
          brands={brandallState?.data?.results}
          defaultValues={{ ...defV, brand: brand?.id }}
          onSubmit={(data) => {
            const ACTION = data?.id
              ? `${LIVESETTINGS}_PATCH`
              : `${LIVESETTINGS}_POST`;
            dispatch({ type: ACTION, payload: data });
          }}
        />
      </RDialog>

      <Box sx={{ p: 2 }}>
        <ActionBar
          hasPermission={user?.permissions?.includes("package.add_package")}
          label="Camera setting"
          setOpen={() => {
            setDefV({});
            setOpen(true);
          }}
          onBtnClick={(s) => {
            if ("previous" == s) {
              navigate("/brands/");
            }
          }}
          btnLabel="Add Settings"
          btnPrevLabel={brand?.id ? "Back" : null}
        />

        <Card
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            backgroundColor: "#f0f0f0",
            px: 2,
            py: 1,
            my: 2,
            borderRadius: 8,
          }}
        >
          <input
            inputRef={ref2}
            variant="outlined"
            size="small"
            placeholder="Search by title"
            fullWidth
          />
          <Button
            className="btn-primary"
            onClick={() => {
              dispatch({
                type: `${LIVESETTINGSALL}_GET`,
                payload: `livesettings/0/?filter_by={"title":"${ref2.current.value}"}`,
              });
            }}
          >
            Search
          </Button>
        </Card>

        <Grid container spacing={2}>
          {livesettingsallState?.data?.results?.map((data, index) => {
            if (!data?.image) data.image = camPng;
            data.no_users = data?.users?.length;

            let key_name = data.proxy_url ? "proxy_url" : "action_url";

            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                <InfoCard
                  keys={[
                    "image",
                    "brand_name",
                    "action",
                    "",
                    key_name,
                    "",
                    "created_at",
                    "",
                    "",
                  ]}
                  data={data}
                  onClick={() => {
                    //navigate("/timelapse-preview/", {})
                  }}
                  onAction={(action, data) => {
                    if (action === "Edit") {
                      setDefV(data);
                      setOpen(true);
                    } else if (action === "Delete") {
                      dispatch({
                        type: `${LIVESETTINGS}_DELETE`,
                        payload: data?.id,
                      });
                    }
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(livesettingsallState?.data?.count / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Box>
    </>
  );
}
